"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const utilities_1 = require("../../utilities");
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const date_1 = require("../../utilities/date");
const helpers_1 = require("./helpers");
exports.default = _ref => {
  let {
    lineData,
    annotationData,
    data,
    xScale,
    yScale,
    selectedLines = []
  } = _ref;
  const [tooltip, setTooltip] = (0, react_1.useState)({
    position: {
      x: null,
      y: null
    },
    key: null,
    value: null,
    direction: 'below',
    title: '',
    color: colors_1.DEFAULT_COLORS[0],
    xLabel: '',
    dotY: null,
    dotWeight: constants_1.DEFAULT_LINE_WEIGHT
  });
  const throttledSetTooltip = (0, react_1.useMemo)(() => lodash_1.default.throttle(newTooltip => {
    setTooltip(newTooltip);
  }, constants_1.DEFAULT_THROTTLING_INTERVAL), []);
  const dataIdsString = (0, utilities_1.getDataIds)(data);
  const lineDataIdsString = (0, utilities_1.getDataIds)(lineData);
  const moveTooltip = (0, react_1.useCallback)(point => {
    if (point) {
      const pointIndex = data.findIndex(_ref2 => {
        let {
          id
        } = _ref2;
        return id === point.line.id;
      });
      const metric = lineData.find(ld => ld.id === point.line.id);
      const dataIndex = point.line.data.findIndex(d => d.key === point.datum.key);
      throttledSetTooltip({
        position: {
          x: xScale(point.datum.x),
          y: yScale(point.datum.y) + (point.direction === 'below' ? 1 : -1) * constants_1.DEFAULT_LINE_WEIGHT
        },
        key: point.datum.x,
        value: point.datum.y,
        direction: point.direction,
        title: metric.tooltipTitle || metric.name,
        type: point.line.y_type,
        color: (0, colors_1.parseColor)(metric.markerColor[dataIndex], metric.color || colors_1.DEFAULT_COLORS[pointIndex]),
        xLabel: (0, date_1.dateFormat)(point.datum.x, point.line.x_type),
        dotY: yScale(point.datum.y),
        dotWeight: constants_1.DEFAULT_LINE_WEIGHT,
        annotation: point.annotation
      });
      return point;
    }
    throttledSetTooltip({
      value: null
    });
    return null;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dataIdsString, lineDataIdsString, xScale, yScale]);
  const hasSameData = (0, react_1.useCallback)((point, lastPoint) => {
    if (!point || !lastPoint || !point.datum || !lastPoint.datum) {
      return false;
    }
    const {
      key: currentKey,
      y: currentY
    } = point.datum;
    const {
      key: oldKey,
      y: oldY
    } = lastPoint.datum;
    return currentKey === oldKey && currentY === oldY;
  }, []);
  const mouseOver = (0, react_1.useCallback)((event, top, left, delaunays, lastPoint, scrubLine) => {
    let x;
    let y;
    if (event.clientX && event.clientY) {
      x = event.clientX - left;
      y = event.clientY - top;
    } else if (event.touches && event.touches.length) {
      x = event.touches[0].clientX - left;
      y = event.touches[0].clientY - top;
    }
    let point = (0, helpers_1.getHoverPoint)(data, lineData, delaunays, x, y, xScale, yScale, selectedLines.length !== 0 ? selectedLines : scrubLine);
    point = (0, helpers_1.findAnnotationForPoint)(point, annotationData);
    return lastPoint === undefined || !hasSameData(point, lastPoint) ? moveTooltip(point) : moveTooltip();
  }, [annotationData, data, hasSameData, lineData, moveTooltip, selectedLines, xScale, yScale]);
  return {
    tooltip,
    setTooltip,
    throttledSetTooltip,
    mouseOver,
    moveTooltip
  };
};